import { _APIHandler } from "../utils/helper";

let baseUrl = "meta";
export const fetchCountries = () => _APIHandler.get(`${baseUrl}/countries`);
export const sendContactReq = (data) => _APIHandler.post(`${baseUrl}/sendContactReq`, data);